import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-686cdeb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "changeSkin" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_5 = { class: "radio_par" }
const _hoisted_6 = ["src"]

import { ref, onMounted } from 'vue'
  import pageTitle from '@/components/pageTitle.vue';
  import { getBrandSkin,saveCompose } from '@/axios/smartMarket';
  import { ElMessage } from 'element-plus';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'changeSkin',
  setup(__props) {

  let disableds = ref(true)
  let radio = ref('')
  let composeList = ref([])
  let brandInfo = ref({id: 0,brand_id:0});

  
  onMounted(() => {
    getBrandSkins();
  })
  function getBrandSkins(){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    getBrandSkin({
      brand_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id
    }).then((data:any) => {
      composeList.value = data.compose_list;
      brandInfo.value = data.brand_info;
      radio.value = data.brand_info.compose_id;
    }).catch((err:any) => {
      
    })
  }
  function saveComposes() {
    saveCompose({
      id: brandInfo.value.id,
      brand_id: brandInfo.value.brand_id,
      compose_id: radio.value
    }).then((data:any) => {
      ElMessage('编辑成功')
      getBrandSkins();
      disableds.value = true;
    }).catch((err:any) => {})
  }

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(pageTitle, { title: "小程序皮肤" }),
    (_unref(disableds))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(disableds) //@ts-ignore
 ? disableds.value = !_unref(disableds) : disableds = !_unref(disableds)))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          onClick: saveComposes
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })),
    (!_unref(disableds))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(disableds) //@ts-ignore
 ? disableds.value = !_unref(disableds) : disableds = !_unref(disableds)))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_radio_group, {
      modelValue: _unref(radio),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(radio) ? (radio).value = $event : radio = $event)),
      disabled: _unref(disableds)
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(composeList), (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_radio, {
              label: item.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(item.compose_name), 1),
                _createElementVNode("img", {
                  class: "radio_img",
                  src: item.effect_image
                }, null, 8, _hoisted_6)
              ]),
              _: 2
            }, 1032, ["label"])
          ]))
        }), 256))
      ]),
      _: 1
    }, 8, ["modelValue", "disabled"])
  ]))
}
}

})